export default "__VITE_ASSET__ipUofuUh__"